module.exports = __webpack_public_path__ + "af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/af.svg
// module id = 408
// module chunks = 0